import { cloneDeep as _cloneDeep, get as _get, set as _set } from 'lodash-es';

export const cloneDeep = _cloneDeep;
export const get = _get;
export const setValue = _set;
